/*
 *
 * Author constants
 *
 */

export const SET_PLUGIN_TYPE_LIST = 'app/Author/SET_PLUGIN_TYPE_LIST';
